(() => {
  const blockedPath = /\/(?:cart|checkout|checkouts)(?:\/|$)|\/account(?:\/orders)?\/?$/;
  const blockedUrl = value => {
    if (!value) return false;
    try {
      return blockedPath.test(new URL(value, location.href).pathname);
    } catch {
      return false;
    }
  };
  const isHeaderCart = element => {
    if (element.tagName !== 'A' || !element.classList.contains('olm-header-cart') && !element.classList.contains('olm-cart-view')) return false;
    try {
      return /\/cart\/?$/.test(new URL(element.getAttribute('href'), location.href).pathname);
    } catch {
      return false;
    }
  };
  const isAllowedCart = element => {
    if (isHeaderCart(element)) return true;
    let pathname;
    try { pathname = new URL(element.getAttribute(element.tagName === 'A' ? 'href' : 'action'), location.href).pathname; } catch { return false; }
    return (element.tagName === 'FORM' && element.classList.contains('olm-product-cart-form') && /\/cart\/add\/?$/.test(pathname)) || (element.tagName === 'A' && element.classList.contains('olm-cart-remove') && /\/cart\/change\/?$/.test(pathname));
  };
  const suppress = root => {
    const elements = [];
    if (root.matches?.('a[href], form[action]')) elements.push(root);
    elements.push(...root.querySelectorAll('a[href], form[action]'));
    for (const element of elements) {
      if (isAllowedCart(element)) {
        element.classList.remove('outlumi-catalog-only-hidden');
        if (!element.classList.contains('olm-cart-view')) element.hidden = false;
        element.removeAttribute('aria-hidden');
        element.removeAttribute('tabindex');
        continue;
      }
      const value = element.getAttribute(element.tagName === 'A' ? 'href' : 'action');
      if (!blockedUrl(value)) continue;
      element.classList.add('outlumi-catalog-only-hidden');
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
      element.setAttribute('tabindex', '-1');
      if (element.tagName === 'FORM') {
        for (const control of element.elements) control.disabled = true;
      }
    }
  };
  suppress(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') suppress(record.target);
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) suppress(node);
      }
    }
  }).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'action']});
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link && !isAllowedCart(link) && blockedUrl(link.getAttribute('href'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (!isAllowedCart(event.target) && blockedUrl(event.target.getAttribute('action'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
